import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ClassName } from '@sim/role';

import { SwalService } from '@atmi/core/services/swal.service';

export interface EntityActionsConf {
  addLabel?: string;
  addToCollectionLabel?: string;
  deleteLabel?: string;
  showAdd?: boolean;
  showAddToCollection?: boolean;
  showDelete?: boolean;
  showExport?: boolean;
}

export const defaultEntityActionsConf: EntityActionsConf = {
  addLabel: 'Nuovo',
  addToCollectionLabel: 'Aggiungi a collezione',
  deleteLabel: 'Rimuovi',
  showAdd: true,
  showAddToCollection: true,
  showDelete: true,
  showExport: true,
};

@Component({
  selector: 'app-entity-actions',
  styleUrls: ['./entity-actions.component.scss'],
  templateUrl: './entity-actions.component.html',
})
export class EntityActionsComponent {
  @Input() className?: ClassName;

  // tslint:disable-next-line:variable-name
  private _config?: EntityActionsConf = defaultEntityActionsConf;
  @Input() set config(v: EntityActionsConf | undefined) {
    this._config = v ? { ...defaultEntityActionsConf, ...v } : defaultEntityActionsConf;
  }
  get config() {
    return this._config;
  }

  @Input() selectedItemsCount = 0;

  @Output() readonly collectionAdd = new EventEmitter();
  @Output() readonly delete = new EventEmitter();
  @Output() readonly add = new EventEmitter();
  @Output() readonly export = new EventEmitter();

  constructor(
    private readonly swalService: SwalService,
    private readonly translate: TranslateService,
  ) {
  }

  async deleteHandler() {
    const confirmResult = await this.swalService.showConfirm({
      text: this.translate.instant('Sei sicuro di voler procedere?'),
      title: this.translate.instant('Eliminazione in corso'),
    });

    if (confirmResult) {
      this.delete.emit();
    }
  }

  async exportHandler() {
    this.export.emit();
  }

  async addToCollectionHandler() {
    this.collectionAdd.emit();
  }
}
